export default __webpack_public_path__ + "static/media/img-0019.54529c35.png";